var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgGraphics2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 444,
    viewBox: "0 0 1440 444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-linejoin: round;\r\n        stroke-width: 30px;\r\n        opacity: 0.04;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #89c7aa;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #f6ae9f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(15 -260)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-1",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(1286 566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-2",
    d: "M1419,130c50.81,0,92,40.518,92,90.5s-41.19,90.5-92,90.5-92-40.518-92-90.5",
    transform: "translate(-101 378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M206,221c51.915,0,94,41.413,94,92.5S257.915,406,206,406s-94-41.413-94-92.5",
    transform: "translate(-112 192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-2",
    d: "M205.5,484.49A37.256,37.256,0,1,1,168,521.745V279",
    transform: "translate(-112 -19)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGraphics2);
export default __webpack_public_path__ + "static/media/BG-Graphics-2.8ca4d431624adfc5e592ee2d67e21862.svg";
export { ForwardRef as ReactComponent };